<template>
  <stock-list :is-stock-status="1"></stock-list>
</template>

<script>
import StockList from './components/StockList'
export default {
  name: 'StockIn',
  components: {
    StockList
  }
}
</script>
